/** Mirrors backend estimate for live preview. */
export function estimateResistanceCalories(
  bodyWeightKg: number | null | undefined,
  exercises: {
    sets: {
      reps: number;
      weightKg: number;
      trackMode?: 'reps' | 'time';
      durationSeconds?: number | null;
      rpe?: number | null;
      rir?: number | null;
    }[];
  }[],
  options?: { durationMinutes?: number | null },
): number {
  const w = bodyWeightKg != null && bodyWeightKg > 0 ? bodyWeightKg : 70;
  let totalSets = 0;
  let tonnage = 0;
  let rpeSum = 0;
  let rpeN = 0;

  for (const ex of exercises) {
    for (const s of ex.sets) {
      const weight = Math.max(0, s.weightKg);
      const isTime = s.trackMode === 'time' && s.durationSeconds != null && s.durationSeconds > 0;
      if (isTime) {
        totalSets++;
        const min = Math.min(45, Math.max(1 / 60, s.durationSeconds! / 60));
        tonnage += weight * min * 0.2;
      } else {
        const reps = Math.max(0, Math.round(s.reps));
        if (reps > 0) {
          totalSets++;
          tonnage += reps * weight;
        }
      }
      if (s.rpe != null && Number.isFinite(s.rpe) && s.rpe > 0) {
        rpeSum += s.rpe;
        rpeN++;
      }
    }
  }
  if (totalSets === 0) return 0;

  const distinct = exercises.filter((e) =>
    e.sets.some((s) => {
      if (s.trackMode === 'time' && s.durationSeconds != null && s.durationSeconds > 0) return true;
      return Math.max(0, Math.round(s.reps)) > 0;
    }),
  ).length;
  const estimatedMinutes = Math.min(120, Math.max(10, totalSets * 1.3 + distinct * 1.8));

  let durationMin = estimatedMinutes;
  if (
    options?.durationMinutes != null &&
    Number.isFinite(options.durationMinutes) &&
    options.durationMinutes > 0
  ) {
    durationMin = Math.min(240, Math.max(5, options.durationMinutes));
  }

  const avgRpe = rpeN > 0 ? rpeSum / rpeN : null;
  let met = 5;
  if (avgRpe != null) {
    met = Math.min(7.8, 5 + Math.max(0, avgRpe - 6) * 0.4);
  }

  const kcalPerMin = (met * 3.5 * w) / 200;
  const durationKcal = kcalPerMin * durationMin;
  const tonnageKcal = (tonnage / Math.max(w, 40)) * 0.045;

  return Math.max(1, Math.round(durationKcal * 0.82 + tonnageKcal * 0.18));
}
